export default __webpack_public_path__ + "static/media/Transfer_certificate_4.213474b2.svg";